import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDeleteUserMutation = () => {
  return useMutation({
    mutationFn: (id: string) =>
      fetchClient.DELETE(endpoints.user, { params: { path: { id } } }),
    onSettled: (_result, _error, id) => {
      invalidateQuery(usersQueryKeys.list())();
      invalidateQuery(usersQueryKeys.detail(id))();
    },
  });
};
